export const toCategories = categories => categories.map(toCategory)

export const toCategory = category => ({
  value: category.id,
  label: category.name,
  system: category.system
})
